import { createFileRoute } from "@tanstack/react-router";
import HowDoesBipolarDisorderAffectTheBrainPage from "@/pages/articles/HowDoesBipolarDisorderAffectTheBrainPage";
export const Route = createFileRoute(
  "/how-does-bipolar-disorder-affect-the-brain",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Bipolar Disorder & the Brain | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How does bipolar disorder affect the brain? Learn about brain circuits, mood regulation, and treatment options in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Bipolar Disorder & the Brain | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How does bipolar disorder affect the brain? Learn about brain circuits, mood regulation, and treatment options in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-does-bipolar-disorder-affect-the-brain",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-does-bipolar-disorder-affect-the-brain",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowDoesBipolarDisorderAffectTheBrainPage />;
}
